import React, { forwardRef } from 'react';

import { BaseMenuOption } from 'src/editor/toolbars/menus/BaseMenuOption';
import type { CommonMenuItemProps } from 'src/editor/toolbars/menus/types';
import { ClientTransforms } from 'src/editor/transforms';
import { useCurrentUserId } from 'src/gql';
import { useAuthorizedTransforms } from 'src/hooks';
import { useEditor } from 'src/layout-engine';
import { useEditingMode } from 'src/store/document/selectors';

interface FitTableToContainerMenuItemProps extends CommonMenuItemProps {
  isNestedTable: boolean;
}

export const FitTableToContainerMenuItem = forwardRef(function FitTableToContainerMenuItem(
  props: FitTableToContainerMenuItemProps,
  ref: React.Ref<HTMLLIElement>
): JSX.Element {
  const { closeRootMenu, isNestedTable, ...rest } = props;
  const currentUserId = useCurrentUserId();
  const { editingMode } = useEditingMode();
  const editor = useEditor();
  const { AuthorizedTransforms } = useAuthorizedTransforms();

  function fitTableToContainer(): void {
    if (!editingMode || !currentUserId) return closeRootMenu();

    AuthorizedTransforms.fitTableToContainer(editor, {
      authorId: currentUserId,
      editingMode,
    });
    ClientTransforms.focus(editor);
    closeRootMenu();
  }

  return (
    <BaseMenuOption
      ref={ref}
      label={isNestedTable ? 'Fit table to cell' : 'Fit table to page'}
      onClick={fitTableToContainer}
      {...rest}
    />
  );
});
